import React from 'react';
import { Box } from '@mui/material';

import { CommonCard } from '@organisms';

import { ReactComponent as IconTeam } from '@assets/svg/team.svg';
import { ReactComponent as IconPeople } from '@assets/svg/people.svg';

interface CardListProps {
  statistics?: UnifedUserStatistics;
}

const CardList: React.FC<CardListProps> = ({ statistics }: CardListProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
        gap: 2,
        gridAutoRows: '1fr',
        mb: 3
      }}
    >
      <CommonCard
        title="Total Unified Users"
        count={statistics?.totalUnifiedCount ?? 0}
        icon={<IconTeam />}
        accent="highlight"
      />
      <CommonCard
        title="Total Core Users"
        count={statistics?.coreUsersCount ?? 0}
        icon={<IconPeople />}
        accent="info"
      />
      <CommonCard
        title="Total Negotiator Users"
        count={statistics?.negotiatorUsersCount ?? 0}
        icon={<IconPeople />}
        accent="secondary"
      />
    </Box>
  );
};

export default CardList;
